// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { GoSignOut } from "react-icons/go";
// import { MdSettings } from "react-icons/md";
// import { RiPlayListAddLine } from "react-icons/ri";
// import { MdHome } from "react-icons/md";
// import { MdOutlineTrendingUp } from "react-icons/md";

// // Assuming you have the required CSS in App.css or any other CSS file

// const SidebarAttack = ({ setIsDrawerVisible, isDrawerVisible }) => {
//   const drawerRef = useRef(null);

//   const toggleDrawer = () => {
//     setIsDrawerVisible(!isDrawerVisible);
//   };

//   const handleClickOutside = (event) => {
//     if (drawerRef.current && !drawerRef.current.contains(event.target)) {
//       setIsDrawerVisible(false);
//     }
//   };

//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//   const toggleDropdown = () => {
//     setIsDropdownOpen(!isDropdownOpen);
//   };
//   const logOut = ()=>{
//     console.log("log out")
//   }

//   useEffect(() => {
//     if (isDrawerVisible) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isDrawerVisible]);

//   return (
//     <div>
//       {/* Overlay */}
//       {isDrawerVisible && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-30"></div>
//       )}

//       {/* Drawer component */}
//       <div
//         id="drawer-navigation"
//         ref={drawerRef}
//         className={`fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform ${
//           isDrawerVisible ? 'translate-x-0' : '-translate-x-full'
//         } w-64 bg-gray-800`}
//         tabIndex="-1"
//         aria-labelledby="drawer-navigation-label"
//       >
//         <h5 id="drawer-navigation-label" className="mb-3 text-base font-semibold uppercase text-gray-400">
//           Play<span className="text-red-500 text-xl">Tube</span>
//         </h5>
//         <button
//           type="button"
//           onClick={toggleDrawer}
//           aria-controls="drawer-navigation"
//           className="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center hover:bg-gray-600 hover:text-white"
//         >
//           <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
//             <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
//           </svg>
//           <span className="sr-only">Close menu</span>
//         </button>
//         <div className="py-4 overflow-y-auto">
//           <ul className="space-y-2 font-medium">
//             <li>
//               <Link to="/" className="flex items-center p-2 rounded-lg text-white hover:bg-gray-700 group">
//                 <div>
//                   <MdHome className="text-xl" />
//                 </div>
//                 <span className="ml-3">Home</span>
//               </Link>
//             </li>
//             <li>
//               <button
//                 type="button"
//                 className="flex items-center w-full p-2 text-base text-white transition duration-75 rounded-lg group hover:bg-gray-700"
//                 aria-controls="dropdown-example"
//                 data-collapse-toggle="dropdown-example"
//                 onClick={toggleDropdown}
//               >
//                 <div>
//                   <RiPlayListAddLine className="text-xl" />
//                 </div>
//                 <span className="flex-1 ml-3 text-left whitespace-nowrap">Playlists</span>
//                 <svg
//                   className="w-3 h-3 transition-transform transform group-hover:rotate-180"
//                   aria-hidden="true"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 10 6"
//                 >
//                   <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
//                 </svg>
//               </button>
//               <ul id="dropdown-example" className={`${isDropdownOpen ? 'block' : 'hidden'} py-2 space-y-2`}>
//                 <li>
//                   <Link to="/watch-l" className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:bg-gray-700">
//                     Watch Later
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/watch-h" className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:bg-gray-700">
//                     History
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/watch-f" className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:bg-gray-700">
//                     Favorite
//                   </Link>
//                 </li>
//               </ul>
//             </li>
//             <li>
//               <Link to="/trends" className="flex items-center p-2 rounded-lg text-white hover:bg-gray-700 group">
//                 <div>
//                   <MdOutlineTrendingUp className="text-xl" />
//                 </div>
//                 <span className="ml-3">Trending Videos</span>
//               </Link>
//             </li>
//             <li>
//               <button onClick={()=>logOut()} className="flex items-center p-2 rounded-lg text-white hover:bg-gray-700 group">
//                 <div>
//                   <GoSignOut className="text-xl" />
//                 </div>
//                 <span className="ml-3">Log out</span>
//               </button>
//             </li>
//             <li>
//               <Link to="/" className="flex items-center p-2 rounded-lg text-white hover:bg-gray-700 group">
//                 <div>
//                   <MdSettings className="text-xl" />
//                 </div>
//                 <span className="ml-3">Setting</span>
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SidebarAttack;









// ---------------------------------------------------

import React, { useState, useEffect, useRef } from 'react';
import { IoSettingsOutline ,IoLogInOutline} from "react-icons/io5";
import { IoIosHome } from "react-icons/io";
import { SiYoutubeshorts } from "react-icons/si";
import { MdSubscriptions,MdContacts ,MdOutlineDetails,MdWatchLater } from "react-icons/md";
import { BsFillInfoSquareFill } from "react-icons/bs";
import { MdFavoriteBorder } from "react-icons/md";
import { RiPlayListAddLine } from "react-icons/ri";
import { FaHistory } from "react-icons/fa";
import { Link } from 'react-router-dom';

const SidebarAttack = ({isDrawerVisible, setIsDrawerVisible,setPopupVisible}) => {

  // const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const drawerRef = useRef(null);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleDrawer = () => {
    setIsDrawerVisible(!isDrawerVisible);
  };

  const handleClickOutside = (event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      setIsDrawerVisible(false);
    }
  };

  const clearData = ()=>{
    localStorage.removeItem('userDetails');
    window.location.reload();
    setPopupVisible(true);
        // localStorage.getItem("userDetails")
  }

  useEffect(() => {
    if (isDrawerVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDrawerVisible]);

  return (
    <div>
      {/* Button to toggle the drawer */}
      {/* <div className="text-center">
        <button
          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
          onClick={toggleDrawer}
        >
          Show navigation
        </button>
      </div> */}

      {/* Overlay */}
      {isDrawerVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-30"></div>
      )}

      {/* Drawer component */}
      <div
        id="drawer-navigation"
        ref={drawerRef}
        className={`fixed top-0 left-0 z-40 h-screen p-4 overflow-y-auto transition-transform ${
          isDrawerVisible ? 'translate-x-0' : '-translate-x-full'
        } bg-gray-800 w-64`}
        tabIndex="-1"
        aria-labelledby="drawer-navigation-label"
      >
        <h5 id="drawer-navigation-label" className="text-base font-semibold text-gray-400 uppercase">
          Menu
        </h5>
        <button
          type="button"
          onClick={toggleDrawer}
          aria-controls="drawer-navigation"
          className="text-gray-400 bg-transparent hover:bg-gray-600 hover:text-white rounded-lg text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center"
        >
          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
          <span className="sr-only">Close menu</span>
        </button>
        <div className="py-4 overflow-y-auto">
          <ul className="space-y-2 font-medium">
            
            

         


            <li>
              <Link to={'/'} className="flex items-center p-2 text-white rounded-lg hover:bg-gray-700 group">
                <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <IoIosHome className='text-xl'/>
                </svg>
                <span className="ml-3">Home</span>
              </Link>
            </li>
            <li>
              <Link to={'/contact'} className="flex items-center p-2 text-white rounded-lg hover:bg-gray-700 group">
                <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <MdContacts  className='text-xl'/>
                </svg>
                <span className="ml-3">Contact</span>
              </Link>
            </li>
            <li>
              <Link to={'/about'} className="flex items-center p-2 text-white rounded-lg hover:bg-gray-700 group">
                <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <BsFillInfoSquareFill className='  text-xl'/>

                </svg>
                <span className="ml-3">About</span>
              </Link>
            </li>

            <div className="my-4 border-t border-gray-600"></div>

            <li>
              <Link to={'/shorts'} className="flex items-center p-2 text-white rounded-lg hover:bg-gray-700 group">
                <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <SiYoutubeshorts className='text-xl'/>
                </svg>
                <span className="ml-3">Shorts</span>
              </Link>
            </li>

            {/* dropDown */}

            
            <li>
              <button
                type="button"
                className="flex items-center w-full p-2 text-base text-white transition duration-75 rounded-lg group hover:bg-gray-700"
                aria-controls="dropdown-example"
                aria-expanded={isDropdownOpen}
                onClick={toggleDropdown}
              >
                <svg
                  className="flex-shrink-0 w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white"
                  
                >
                  <RiPlayListAddLine className='text-xl '/>
                </svg>
                <span className="flex-1 ms-3 text-left ml-2 whitespace-nowrap">Playlist</span>
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={`m1 1 4 4 4-4 ${isDropdownOpen ? 'transform rotate-180' : ''}`}
                  />
                </svg>
              </button>
              <ul
                id="dropdown-example"
                className={`py-2 space-y-2 ${isDropdownOpen ? '' : 'hidden'}`}
              >
                
                <li>
                  <Link to={'/watch-s'} className="flex items-center px-2 py-1 text-white rounded-lg hover:bg-gray-700 group">
                    <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <MdSubscriptions className='text-xl'/>
                    </svg>
                    <span className="ml-3">Subscription</span>
                  </Link>
                </li>
                <li>
                  <Link to={'/watch-f'} className="flex items-center px-2 py-1 text-white rounded-lg hover:bg-gray-700 group">
                    <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <MdFavoriteBorder className='text-xl'/>
                    </svg>
                    <span className="ml-3">Favorite</span>
                  </Link>
                </li>

                <li>
                  <Link to={'/watch-h'} className="flex items-center px-2 py-1 text-white rounded-lg hover:bg-gray-700 group">
                    <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <FaHistory className='text-xl'/>
                    </svg>
                    <span className="ml-3">History</span>
                  </Link>
                </li>


                <li>
                  <Link to={'/watch-l'} className="flex items-center px-2 py-1 text-white rounded-lg hover:bg-gray-700 group">
                    <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                      <MdWatchLater  className='text-xl'/>
                    </svg>
                    <span className="ml-3">Watch Later</span>
                  </Link>
                </li>
              </ul>
            </li>



            

            <li>
              <Link to='/settings' className="flex items-center p-2 text-white rounded-lg hover:bg-gray-700 group">
                <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <IoSettingsOutline className='text-xl'/>
                </svg>
                <span className="ml-3">Settings</span>
              </Link>
            </li>
            <li>
              <button onClick={()=>clearData()} className="flex w-full items-center p-2 text-white rounded-lg hover:bg-gray-700 group">
                <svg className="w-5 h-5 text-gray-400 transition duration-75 group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                  <IoLogInOutline className='text-xl'/>
                </svg>
                <span className="ml-3">Log out</span>
              </button>
            </li>

             
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SidebarAttack;



// --------------------------------

// import React, { useState, useEffect, useRef } from 'react';
// import { IoSettingsOutline } from "react-icons/io5";

// const SidebarAttack = ({setIsDrawerVisible, isDrawerVisible}) => {

//    // const [isDrawerVisible, setIsDrawerVisible] = useState(false);
//    const drawerRef = useRef(null);

//    const toggleDrawer = () => {
//       setIsDrawerVisible(!isDrawerVisible);
//    };

//    const handleClickOutside = (event) => {
//       if (drawerRef.current && !drawerRef.current.contains(event.target)) {
//          setIsDrawerVisible(false);
//       }
//    };

//    useEffect(() => {
//       if (isDrawerVisible) {
//          document.addEventListener('mousedown', handleClickOutside);
//       } else {
//          document.removeEventListener('mousedown', handleClickOutside);
//       }
//       return () => {
//          document.removeEventListener('mousedown', handleClickOutside);
//       };
//    }, [isDrawerVisible]);

//    return (
//       <div>
//          {/* Button to toggle the drawer */}
//          {/* <div className="text-center">
//             <button
//                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
//                type="button"
//                onClick={toggleDrawer}
//             >
//                Show navigation
//             </button>
//          </div> */}

//          {/* Overlay */}
//          {isDrawerVisible && (
//             <div className="fixed inset-0 bg-black bg-opacity-50 z-50"></div>
//          )}

         
//          <div
//             id="drawer-navigation"
//             ref={drawerRef}
//             className={`fixed top-[4rem] left-0 z-60 h-screen p-4 overflow-y-auto transition-transform ${isDrawerVisible ? 'translate-x-0' : '-translate-x-full'
//                } bg-white w-64 dark:bg-gray-900`}
//             tabIndex="-1"
//             aria-labelledby="drawer-navigation-label"
//          >
//             <h5 id="drawer-navigation-label" className=" mb-3 text-base font-semibold text-gray-500 uppercase dark:text-gray-400">
//                Play<span className="text-red-500 text-xl">Tube</span>
//             </h5>
//             <button
//                type="button"
//                onClick={toggleDrawer}
//                aria-controls="drawer-navigation"
//                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
//             >
//                <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
//                   <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
//                </svg>
//                <span className="sr-only">Close menu</span>
//             </button>
//             <div className="py-4 overflow-y-auto">
//                <ul className="space-y-2 font-medium">
//                   <li>
//                      <a href="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
//                         <svg className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 21">
//                            <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5.5 0 1 0 6.538 12.547L13 10.985v-5.3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5.3l-.5 3.212A7.5 7.5 0 0 0 16.975 11ZM21 21h-5v-2h5v2Zm-2.965-3.117-2.121-2.121a1 1 0 0 1 0-1.414l2.121-2.121a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.414l-2.121 2.121a1 1 0 0 1-1.414 0Z" />
//                         </svg>
//                         <span className="ml-3">Dashboard</span>
//                      </a>
//                   </li>
//                   <li>
//                      <a href="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
//                         <svg className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
//                            <path d="M16.143 10H11.857A1.857 1.857 0 0 0 10 11.857v4.286A1.857 1.857 0 0 0 11.857 18h4.286A1.857 1.857 0 0 0 18 16.143v-4.286A1.857 1.857 0 0 0 16.143 10Z" />
//                         </svg>
//                         <span className="ml-3">Kanban</span>
//                      </a>
//                   </li>
//                   <li>
//                      <a href="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
//                         <svg className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
//                            <path d="M8.1 18a1 1 0 0 1-.77-.36L.5 9.36a1 1 0 0 1 .02-1.31L7.4.36A1 1 0 0 1 8.2 0h9.7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8.1ZM5.64 9 10 13.36V4.64L5.64 9ZM7.64 16h8V2h-8v1.64l3.64 3.36a1 1 0 0 1 .36.77V14.3a1 1 0 0 1-.36.77L7.64 16Z" />
//                         </svg>
//                         <span className="ml-3">Inbox</span>
//                         <span className="inline-flex items-center justify-center w-3 h-3 p-3 ml-3 text-sm font-medium text-blue-800 bg-blue-100 rounded-full dark:bg-blue-900 dark:text-blue-300">3</span>
//                      </a>
//                   </li>
//                   <li>
//                      <a href="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
//                         <svg className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
//                            <path d="M6 2h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1ZM5 6h10v2H5V6Zm11 5H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1ZM6 14h2v4H6v-4Zm6 4h-2v-4h2v4Z" />
//                         </svg>
//                         <span className="ml-3">Files</span>
//                      </a>
//                   </li>
//                   <li>
//                      <a href="#" className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
//                         <svg className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
//                            <path d="M8 9h4v2H8V9Zm0 4h4v2H8v-2Zm7-9a1 1 0 0 0-1-1h-4V2a2 2 0 0 0-4 0v1H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4Z" />
//                         </svg>
//                         <span className="ml-3">Tasks</span>
//                      </a>
//                   </li>
//                </ul>
//             </div>
//          </div>
//       </div>
//    );
// };

// export default SidebarAttack;


